{
  "api_url": "https://apidev.bisom.fr/",
  "sentry": {
    "dsn": "https://e4628cf9c8b341dc9001d62537f02c40@glitchtip.bisom.fr/7",
    "environment": "develop",
    "debug": false,
    "sample_rate": 0.5
  }
}
